import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-settings-mdm>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opname} edit={edit} selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
    submitfunc={submitHandler}>
  
    <yield to="fields">
      <div class="paedml-input-group">
        <div class="pb-1">
          MDM Server:
        </div>
        <div class="row">
          <div class="col-md-6">
              <paedml-form-input name="externalServerUrl" label="FQDN" 
                required data-msg="Bitte geben Sie den FQDN ein"
                />
          </div>
          <div class="col-md-6">
              <paedml-form-input name="ipAddress" label="IP-Adresse" 
                required data-msg="Bitte geben Sie eine IP-Adresse ein"
                data-rule-ipaddress data-msg-ipaddress="Bitte geben Sie eine gültige IP-Adresse ein."
                />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
              <paedml-form-input name="databaseIpAddress" label="IP-Adresse der Datenbank / S3-Speicher" 
                required data-msg="Bitte geben Sie eine IP-Adresse ein"
                data-rule-ipaddress data-msg-ipaddress="Bitte geben Sie eine gültige IP-Adresse ein."
                />
            </div>
            <div class="col-md-6">
              <paedml-form-input name="remoteHost" label="ProxyPass-Parameter" 
                required data-msg="Bitte geben Sie den ProxyPass-Parameter ein"
                data-rule-protocolipaddressport data-msg-protocolipaddressport="Erlaubt sind: https://Server-IP:Port oder http://Server-IP:Port"
                />
            </div>
        </div>
      </div>
      
      <div class="paedml-input-group">
        <div class="row">
          <div class="col-md-12">
              <paedml-form-input name="ldapServer" label="LDAP Server" 
                required data-msg="Bitte geben Sie die LDAP Url ein"
                data-rule-ldapserver data-msg-ldapserver="ldap://Server-IP (Name):Port für LDAP oder ldaps://Server-IP (Name):Port für eine verschlüsselte LDAPS-Verbindung"
                />
          </div>
          <div class="col-md-12">
            
          </div>
        </div>
      </div>

      <div class="paedml-input-group">
        <div class="pb-1">
          MDM Systemadministrator:
        </div>
        <div class="row">
          <div class="col-md-12">
            <paedml-form-input name="administratorEmail" label="E-Mail" 
              data-rule-emailextra data-msg-emailextra="Bitte geben Sie eine gültige E-Mailadresse ein."
              />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <paedml-form-input name="administratorPassword" ref="pwSystAdm"
                      label="Kennwort" 
                      type="password" inputid="pwSystAdm"
                      required data-msg="Bitte geben Sie ein Kennwort ein" 
                      data-rule-maxlength="64" data-msg-maxlength="Das Kennwort darf nicht mehr als 64 Zeichen enthalten!" 
                      data-rule-minlength="{parent.getMinPwLength()}" data-msg-minlength="Das Kennwort muss mindestens {parent.getMinPwLength()} Zeichen haben!" 
                      data-rule-minonecharnumsym data-msg-minonecharnumsym="Mindestens ein Kleinbuchstabe, ein Großbuchstabe, eine Ziffer und ein Sonderzeichen."
              />
          </div>
          <div class="col-sm-6">
              <paedml-form-input type="password" 
                      label="Kennwortbestätigung"
                      placeholder="Kennwort bestätigen"
                      required data-msg="Bitte bestätigen Sie das Kennwort" 
                      data-rule-equalto="#pwSystAdm" data-msg-equalto="Die Kennwörter stimmen nicht überein!" 
              />
          </div>
        </div>
      </div>

      <div class="paedml-input-group">
        <div class="pb-1">
            MDM Dienstkonto:
          </div>
          <div class="row">
            <div class="col-md-6">
              <paedml-form-input name="serviceAccountUsername" label="Benutzername" 
                readonly value={parent.data.mdmAdminUsername}
                />
            </div>
            <div class="col-sm-6">
                    <paedml-form-input name="serviceAccountPassword" label="Kennwort" 
                        type="password" 
                        required data-msg="Bitte geben Sie ein Kennwort ein" 
                        data-rule-maxlength="64" data-msg-maxlength="Das Kennwort darf nicht mehr als 64 Zeichen enthalten!" 
                        data-rule-minlength="{parent.getMinPwLength()}" data-msg-minlength="Das Kennwort muss mindestens {parent.getMinPwLength()} Zeichen haben!" 
                        data-rule-minonecharnumsym data-msg-minonecharnumsym="Mindestens ein Kleinbuchstabe, ein Großbuchstabe, eine Ziffer und ein Sonderzeichen."
                    />
          </div>
      </div>

    </yield>
  </paedml-modal>
    
    <script>
      import API from '../../api'
      import {autoMapRowToData} from '../../util/modal-util'

      this.session = Session
      this.opname = this.opts.opname
      this.api = this.opts.api

      this.edit = false

      this.settings = {
          minPwLength: 8
      }

      this.getMinPwLength = () => this.settings.minPwLength

      this.data = {}

      this.on('dataRequested', () => {
          return this.api.getSettings()
            .then(rsp => {
              const [data, status] = rsp
              if (status.success) {
                
                this.data = data
                this.data.externalServerUrl = data.externalServerUrl
                this.data.administratorEmail = data.administratorEmail 
                this.data.administratorPassword = data.administratorPassword
                this.data.serviceAccountPassword = data.serviceAccountPassword
                this.data.remoteHost = data.remoteHost
                this.data.ipAddress = data.ipAddress
                this.data.serviceAccountUsername = data.serviceAccountUsername
                this.data.ldapServer = data.ldapServer
                this.data.databaseIpAddress = data.databaseIpAddress
        
                this.update()

                $('input[name=externalServerUrl]', this.root).val(this.data.externalServerUrl)
                $('input[name=administratorEmail]', this.root).val(this.data.administratorEmail)
                $('input[name=administratorPassword]', this.root).val(this.data.administratorPassword)
                $('input[name=serviceAccountPassword]', this.root).val(this.data.serviceAccountPassword)
                $('input[name=remoteHost]', this.root).val(this.data.remoteHost)
                $('input[name=ipAddress]', this.root).val(this.data.ipAddress)
                $('input[name=serviceAccountUsername]', this.root).val(this.data.serviceAccountUsername)
                $('input[name=ldapServer]', this.root).val(this.data.ldapServer)
                $('input[name=databaseIpAddress]', this.root).val(this.data.databaseIpAddress)

              }
            })
      })

      this.on('rowMappingRequested', cols => {
        autoMapRowToData(this, cols)
      })

      this.submitHandler = formData => {
          return this.api.saveSettings(formData)
            .then(rsp => {
              const [data, status] = rsp
              if (status.success) {
                
                this.parent.trigger('reloadTable')
                return this.opname + ' erfolgreich durchgeführt'
              }

              console.error('error-status', status)
              console.error('error-data', data)
              if (data.message) {
                return Promise.reject(data.message)
              }
              return Promise.reject('Fehler bei ' + this.opname + '! MDM Grundeinstellungen wurden nicht gesetzt.')
            })
        }

    </script>
</paedml-modal-settings-mdm>
